// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__QxLSa","content":"Layout_content__2zCUh","sidebarTrigger":"Layout_sidebarTrigger__N7W_i","sidebarContainer":"Layout_sidebarContainer__3S2JT"};